import { FormBody } from 'twyne-new.ui';

import { Wrapper, Search, Separator, Total, Showing, GridToggles } from '@/components/Grid/components/header/Heading';
import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { useSubIdStore } from '../../store';
import GridHeaderButtons from '../HeaderButtons';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'

function SubIdGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    events: useEvents(),
  })

  return <DefaultGrid
    className='h-full'
    heading={<Wrapper>
      <Search />
      <Separator />
      <GridToggles />
      <Separator />
      <Total />
      <Showing />
      <Separator />
      <GridHeaderButtons />
    </Wrapper>}
    filters={null}
  />
}

export default function SubIdGridLayout() {
  return <GridProvider store={useSubIdStore()}>
    <FormBody className='pb-4 h-full'>
      <div className='twy-bg-base-accent shadow rounded h-full'>
        <SubIdGrid />
      </div>
    </FormBody>
  </GridProvider>
}
